export const AVAILABLE_PINCODES = "global/static/pincode/availablepincodes";

/**
 * Generates the serviceability API endpoint URL to fetch pincodes for a two-digit prefix.
 *
 * @param {string} pincode first two digits of the pincode.
 * @returns {string} The API endpoint URL.
 */
export const fetchPincodeJson = (pincode) => {
  return `/serviceability/v1/pincodes/${pincode}`;
};
/**
 * Generates the API endpoint URL to fetch the available pincodes based on latitude and longitude.
 *
 * @returns {string} The API endpoint URL.
 */
export const fetchCityPincodeBasedOnLocation = (latitude, longitude) => {
  return `/control/getPinCodeByPostalAddress?latitude=${latitude}&longitude=${longitude}`;
};

/**
 * Generates the serviceability API endpoint URL for a Google place's details (lat/long + pincode).
 * @param {string} placeId - Google place id.
 * @returns {string} The API endpoint URL.
 */
export const fetchPlaceDetails = (placeId) => {
  return `/serviceability/v1/place/details?placeId=${encodeURIComponent(placeId)}`;
};
